import { GenericFollowUpOrderContent, Task } from "../../shared/task";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfigService } from "../../core/config.service";
import { TaskService } from "../../shared/task.service";

interface TaskWithGenericFollowUpOrderContent extends Task {
  content: GenericFollowUpOrderContent;
}

@Component({
  selector: "om-generic-follow-up-order-details",
  templateUrl: "./generic-follow-up-order-details.component.html",
  styleUrls: ["./generic-follow-up-order-details.component.scss", "../_shared-task-details.scss"],
})
export class GenericFollowUpOrderDetailsComponent implements OnInit {
  @Input() task: TaskWithGenericFollowUpOrderContent;
  @Output() completed = new EventEmitter();
  submitting = false;

  constructor(public config: ConfigService, private taskService: TaskService) {}

  ngOnInit() {
    this.task.content.message = "";
  }

  submitMessage() {
    this.submitting = true;

    this.completed.emit({
      completionData: { message: this.task.content.message },
    });
  }
}
